import type { WebediaPlayer } from '@webedia-services/webedia-player';

import type { PlayerCustomData } from 'website/module/player';
import {
  loadMediametrieLib,
  quartileEventTracking,
  trackerHandler
} from 'website/tracking/player/mediametrie.internals';
import { getCurrentCustomData } from 'website/tracking/player/utils';

const initMediametrie = (
  webediaPlayer: WebediaPlayer,
  customData: PlayerCustomData,
  playerName: string
) => {
  webediaPlayer.addEventListener('ready', () => {
    loadMediametrieLib(webediaPlayer, customData).then(() => {
      window.addEventListener('beforeunload', () => {
        const currentCustomData = getCurrentCustomData(
          customData,
          webediaPlayer
        );
        trackerHandler(webediaPlayer, 'stop', currentCustomData, playerName);
      });
    });
  });
  webediaPlayer.addEventListener('quartile', customEvent => {
    const currentCustomData = getCurrentCustomData(customData, webediaPlayer);
    quartileEventTracking(
      webediaPlayer,
      customEvent,
      currentCustomData,
      playerName
    );
  });
  webediaPlayer.addEventListener('quartile-postroll', customEvent => {
    const currentCustomData = getCurrentCustomData(customData, webediaPlayer);
    quartileEventTracking(
      webediaPlayer,
      customEvent,
      currentCustomData,
      playerName
    );
  });
  webediaPlayer.addEventListener('pause', ({ detail: { position } }) => {
    const currentCustomData = getCurrentCustomData(customData, webediaPlayer);
    trackerHandler(webediaPlayer, 'pause', currentCustomData, playerName, {
      actionPosition: Math.round(position)
    });
  });
  webediaPlayer.addEventListener('resume', ({ detail: { position } }) => {
    const currentCustomData = getCurrentCustomData(customData, webediaPlayer);
    trackerHandler(webediaPlayer, 'play', currentCustomData, playerName, {
      actionPosition: Math.round(position)
    });
  });
  webediaPlayer.addEventListener('seek', ({ detail: { offset, position } }) => {
    const currentCustomData = getCurrentCustomData(customData, webediaPlayer);
    trackerHandler(webediaPlayer, 'pause', currentCustomData, playerName, {
      actionPosition: Math.round(position)
    });
    trackerHandler(webediaPlayer, 'play', currentCustomData, playerName, {
      actionPosition: Math.round(offset)
    });
  });
};

export default initMediametrie;
